<template>
<div>
  <el-dialog :title="name" :visible.sync="visible" width="600px" top="7vh" :close-on-click-modal="false">

    <div>
      <div class="hdr-tools">
        <div class="input-item">
          <div class="hdr-tools-name">密钥名:</div>
          <el-input size="mini" class="hdr-tools-input" v-model="inputName" />
        </div>

        <div class="input-item">
          <div class="hdr-tools-name">密钥密码:</div>
          <el-input size="mini" class="hdr-tools-input" v-model="inputPassword" show-password placeholder="可选" />
        </div>
      </div>
      <br>
      <div class="password-tips">不修改私钥只修改密码不会修改密钥中的密码，只是使用密钥时会用这里的密码来解密密钥</div>

      <div class="validate-result">{{tips}}</div>

      <div class="input-area">
        <h4>私钥</h4>
        <el-input type="textarea" placeholder="粘贴私钥(必填)" v-model="inputPrivateKey" maxlength="4096" show-word-limit :autosize="{minRows: 5, maxRows: 8}" />
      </div>
      <br>
      <div class="input-area">
        <h4>公钥</h4>
        <el-input type="textarea" placeholder="粘贴公钥(可选)" v-model="inputPublicKey" maxlength="4096" show-word-limit :autosize="{minRows: 3, maxRows: 5}" />
      </div>
      <br>
      <div class="input-area">
        <h4>SSH Authorized Key</h4>
        <el-input type="textarea" placeholder="粘贴 SSH Authorized Key(可选)" v-model="inputSshAuthorizedKey" maxlength="4096" show-word-limit :autosize="{minRows: 3, maxRows: 5}" />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="hide">关闭</el-button>
        <el-button type="primary" @click="okHandler" size="mini">提 交</el-button>
      </span>
  </el-dialog>
</div>
</template>

<script>
import model from "../../model"
export default {
  name: "editKey",
  data() {
    return {
      visible: false,

      name: undefined,    // 传递进来的密钥名
      keyPair: undefined, // 传递进来的 KeyPair

      tips: undefined,

      inputName: undefined,
      inputPassword: undefined,
      inputPrivateKey: undefined,
      inputPublicKey: undefined,
      inputSshAuthorizedKey: undefined,
    }
  },
  watch: {
    inputName: function() {
      if (this.inputName === "" || this.inputName === undefined) {
        this.tips = "密钥名不能为空"
        return
      }

      // 没有修改密钥名
      if (this.inputName === this.name) {
        return
      }

      let self = this
      this.api.hifs.getPath(self.path, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          self.tips = "检查同名密钥是否存在出错"
        } else {
          // 文件已存在
          if (data == true) {
            self.tips = "同名密钥已存在"
            return
          }
          self.tips = ""
        }
      })
    }
  },
  computed: {
    path: function() {
      return `/keys/${this.inputName}`
    },
  },
  methods: {
    show(name, keyPair) {
      this.name = name
      this.keyPair = keyPair
      this.keyPair2Input()

      this.visible = true
    },
    hide() {
      this.visible = false
    },
    keyPair2Input() {
      for (let k in this.keyPair) this[`input${k}`] = this.keyPair[k]
      this.inputName = this.name
      console.log("this.keyPair:", this.keyPair)
      if (this.keyPair.Passphrase) {
        let self = this

        let opts = {
          'encryptedPassword': this.keyPair.Passphrase // String | 加密后的字符串
        };
        self.api.sess.getSessionPasswordDecrypted(opts, (error, data, response) => {
          if (error) {
            self.api.errHandler(self, error, response)
            return
          }
          self.inputPassword = data
        })
      }
    },
    postKey(encryptedPassword) {
      let self = this
      let kp = new model.KeyPair()
      kp.PrivateKey = self.inputPrivateKey
      kp.Passphrase = encryptedPassword
      kp.PublicKey = self.inputPublicKey
      kp.SshAuthorizedKey = self.inputSshAuthorizedKey

      console.log("post key:", kp)

      let blob = new Blob([JSON.stringify(kp)])
      self.api.hifs.postFile(self.path, blob, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        self.$message.success(`提交密钥 ${self.name} 成功`)
        self.$emit("success")
      })
    },
    encryptPasswordAndPostKey: function() {
      // 没有输入密码，则不需要获取加密后的密码
      if (this.inputPassword === "" || this.inputPassword === undefined) {
        this.postKey("")
        return
      }

      // 密码不为空，需要先获取加密后的密码，再推送密钥文件
      let self = this
      let opts = {
        'password': this.inputPassword // String | 密码
      }
      self.api.sess.getSessionPasswordEncrypted(opts, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        if (!data) {
          self.$notify.error("encrypt password failed: no response data")
          return
        }
        self.postKey(data)
      })
    },
    okHandler: function() {
      if (this.inputName === "" || this.inputName === undefined) {
        this.tips = "invalid name"
        return
      }

      if (this.inputPrivateKey === "" || this.inputPrivateKey === undefined) {
        this.tips = "invalid private key"
        return
      }

      this.encryptPasswordAndPostKey()
      // 密钥名修改, 删除旧的文件
      if (this.inputName !== this.name) {
        this.api.delFile(this, this.env.key.getPathByName(this.name))
      }
    },
  },
}
</script>

<style scoped>
.hdr-tools {
  display: flex;

  justify-content: space-between;
}
.input-item {
  display: flex;
  align-items: baseline;
}
.hdr-tools-name {
  flex-grow: 0;
  padding-right: 0.5em;
  word-break: keep-all;

  user-select: none;
}
.hdr-tools-input {
  width: 200px;
}
.validate-result {
  width: 100%;
  padding-top: 0.6em;
  font-size: 0.8em;

  display: flex;
  justify-content: flex-end;
  color:brown;
}
.input-area {
  text-align: left;
}
.password-tips {
  font-size: 0.8em;
  color: gray;
  text-align: right;
}
</style>
